import { render, staticRenderFns } from "./strengthModel.vue?vue&type=template&id=90d4d7a0&scoped=true&"
import script from "./strengthModel.vue?vue&type=script&lang=js&"
export * from "./strengthModel.vue?vue&type=script&lang=js&"
import style0 from "./strengthModel.vue?vue&type=style&index=0&id=90d4d7a0&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d4d7a0",
  null
  
)

export default component.exports